import type { ListType } from '../models/app';

export const faqCategories: ListType[] = [
  { id: 1, key: 'call', label: 'Calls' },
  { id: 2, key: 'client-dashboard', label: 'Client Dashboard' },
  { id: 3, key: 'payments', label: 'Cost & Payments' },
  { id: 4, key: 'driver', label: 'Driver Information' },
  { id: 5, key: 'general', label: 'General Questions' },
  { id: 6, key: 'meals', label: 'Gourmet' },
  { id: 7, key: 'groceries', label: 'Groceries' },
  { id: 8, key: 'home-services', label: 'Home Services' },
  { id: 9, key: 'marketing', label: 'Marketing' },
  { id: 10, key: 'need-love', label: 'Need Love' },
  { id: 11, key: 'partnership', label: 'Partnership' },
  { id: 12, key: 'medications', label: 'Pharmacy & Special Requests' },
  { id: 13, key: 'registration', label: 'Registration' },
  { id: 14, key: 'transportation', label: 'Transportation' },
  { id: 15, key: 'troubleshooting', label: 'Troubleshooting' },
];
